import styled, { css } from "styled-components/macro";

import { COLOR_VALUES } from "shared/config/colors";
import HStack from "shared/components/layout/stack/HStack";

export const StyledHStack = styled(HStack)`
    ${(props) =>
        props.borderBottom &&
        css`
            border-bottom: 1px solid ${COLOR_VALUES.Gray_6};
            padding-bottom: 40px;
        `}
    gap: 2rem;
`;
